import { render } from "./DialogueBox.vue?vue&type=template&id=c061d6b2&scoped=true"
import script from "./DialogueBox.vue?vue&type=script&lang=js"
export * from "./DialogueBox.vue?vue&type=script&lang=js"

import "./DialogueBox.vue?vue&type=style&index=0&id=c061d6b2&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c061d6b2"]])

export default __exports__